module.exports = __webpack_public_path__ + "img/star10-10.14b6affb.svg";